import { isEmpty } from 'lodash-es';
import type { FC, ReactNode } from 'react';

import { useFeatureIsOn } from '@zen/FeatureFlag';
import type { SuggestionAttribute } from '@zen/graphql/types.generated';
import type { Nullable } from '@zen/utils/typescript';

import Suggestions from '../Suggestions';
import type { Suggestion } from '../types';

interface Props {
  attribute: SuggestionAttribute;
  currentValue?: Nullable<number> | Nullable<string>;
  inlineFieldNode: ReactNode;
  refetchQueries: string[];
  suggestions: Suggestion[];
}

export const InlineFieldWithSuggestions: FC<Props> = ({
  attribute,
  currentValue = '',
  inlineFieldNode,
  refetchQueries,
  suggestions
}) => {
  const isSuggestionsEnabled: boolean = useFeatureIsOn('io-suggestions');

  const filteredSuggestions: Suggestion[] = suggestions?.filter((suggestion) => suggestion.targetAttribute === attribute);

  if (!isSuggestionsEnabled || !suggestions || filteredSuggestions.length === 0) {
    return inlineFieldNode ?? '-';
  }

  return (
    <>
      {inlineFieldNode}
      <Suggestions
        currentValue={currentValue?.toString() || ''}
        originalValuePresent={currentValue !== '-' && !isEmpty(currentValue)}
        suggestions={filteredSuggestions}
        refetchQueries={refetchQueries}
      />
    </>
  );
};
